import * as _4 from 'lodash4';
export class LoginRemoteController {
  private logged_in_default_url: string = '';
  private sso_login_url: string = '';
  private loginButtonlabel: string = 'Login with your school account';
  private return_to_url: string = '';
  private storedDeeplink = '';
  private loginHelpButtonLabel: string = 'Need help logging in?';
  constructor(
    private ngAuthenticationQueryModel: any,
    private $state: ng.ui.IStateService,
    private ngDeeplinkConfig: any,
    private appConfigModel: any
  ) {
    this.storedDeeplink = this.ngDeeplinkConfig.getOriginalDeeplink();
    this.logged_in_default_url = this.$state.href(this.ngDeeplinkConfig.getDefaultState(), {}, { absolute: true });
    this.return_to_url = encodeURIComponent(
      !_4.isEmpty(this.storedDeeplink) ? this.storedDeeplink : this.logged_in_default_url
    );
    this.sso_login_url = `${_4.get(ngAuthenticationQueryModel.read(), 'member.login_url')}?return_to=${
      this.return_to_url
    }`;
    this.loginButtonlabel = _4.get(
      appConfigModel,
      'model.member_configs.auth-login_button_label',
      this.loginButtonlabel
    );
    this.loginHelpButtonLabel = _4.get(
      appConfigModel,
      'model.member_configs.auth-login_help_button_label',
      this.loginHelpButtonLabel
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/views/type_remote/type_remote.ts